// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__qOVIo","col":"Table_col__1JCzh","fulfillmentStatus":"Table_fulfillmentStatus__VF_Xr","emailCol":"Table_emailCol__3sQ10"};